"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BorderBox = void 0;

var _themeGet = require("@styled-system/theme-get");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _BorderBoxBase = require("./BorderBoxBase");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * A `div` that has a common border and padding set by default, with an optional
 * `hover` property for visually focusing content.
 */
var BorderBox = (0, _styledComponents.default)(_BorderBoxBase.BorderBoxBase).withConfig({
  displayName: "BorderBox",
  componentId: "sc-18mwadn-0"
})(["", ";"], function (_ref) {
  var hover = _ref.hover;
  return hover && (0, _styledComponents.css)([":hover{border-color:", ";}"], (0, _themeGet.themeGet)("colors.black60"));
});
exports.BorderBox = BorderBox;
BorderBox.displayName = "BorderBox";
//# sourceMappingURL=BorderBox.js.map